import { MainStore } from '../stores/MainStore';
import { MixedMediaStore } from '../stores/MixedMediaStore';
import { ProductInfoStore } from '../stores/ProductInfoStore';
import { VariantStore } from '../stores/VariantStore';
import React from 'react';

export interface IInjectedProps {
    store?: MainStore;
    isStickyHeader?: boolean;
}

export interface IMixedMediaInjectedProps extends IInjectedProps{
    floatElementRef: React.RefObject<HTMLDivElement | null>;
    stickyElementRef: React.RefObject<HTMLDivElement | null>;
}

export interface IOrderModuleInjectedProps extends IInjectedProps {
    basedElementRef: React.RefObject<HTMLDivElement | null>;
}

export interface IVariantStore {
    variantStore?: VariantStore;
    isStickyHeader?: boolean;
}

export interface IMixedMediaStore {
    mixedMediaStore?: MixedMediaStore;
}

export interface IProductInfoStore {
    productInfoStore: ProductInfoStore;
}

export interface ILocalization {
    generalL10n: IGeneralL10n;
    redOnlyL10n?: IRedOnlyL10n;
    // wwsOnlyL10n?: IWWSOnlyL10n;
    glbOnlyL10n?: IGLBOnlyL10n;
}

export interface IGeneralL10n {
    esAppLoginPageUrl: string;
    buttonApply: string;
    buttonClose: string;
    buttonCancel: string;
    textColor: string;
    textSize: string;
    textModel: string;
    textDiameter: string;
    clothingSizeTableUrl: string;
    glovesSizeTableUrl: string;
    sizeTable: string;
    textLength: string;
    smallerSize: string;
    matchingSize: string;
    largerSize: string;
    fittingAccuracy: string;
    deliveryTimeText: string;
    note: string;
    deliveryTime: string;
    glovesRecommendationShutterTitle: string;
    glovesRecommendationDescription: string;
    selection: string;
    isNew: string;
    withVatLocale: string;
    withoutVatLocale: string;
    withVatAcronym: string;
    withoutVatAcronym: string;
    basePriceLocale: string;
    basketButtonLocale: string;
    articleNotAvailable: string;
    articleSoldOut: string;
    personalizationBannerHeadline: string;
    personalizationBannerDescriptionText: string;
    personalizationBannerButtonLabel: string;
    colorIcon: string;
    priceFromLocale: string;
    more: string;
    less: string;
    deliveryTimeKnownDateLocale: string;
    deliveryTimeUnknownDateLocale: string;
    deliveryTimeFromCalWeekLocale: string;
    rrp: string;
    sale: string;
    priceAdvantage: string;
    whileStocksLast: string;
    logoService: string;
    personalization: string;
    personalizationLoginHint: string;
    personalizationRegistrationConfirmHint: string;
    personalise: string;
    personaliseInfo: string;
    designYourself: string;
    designYourselfInfo: string;
    withConsulting: string;
    withConsultingInfo: string;
    propertiesAndStandards: string;
    safetyClassesOverview: string;
    onlineCatalog: string;
    discoverNow: string;
    mixAndMatch: string;
    left: string;
    right: string;
    datasheetHint: string;
    datasheet: string;
    datasheets: string;
    productInfo: string;
    briefDescription: string;
    specs: string;
    extras: string;
    approxWeight: string;
    gramsInSize: string;
    materialLabel: string;
    grammage: string;
    careLabel: string;
    companyNameSimple: string;
    shareButtonLocale: string;
    shareLinkText: string;
    shareLinkBody: string;
    pdfDownload: string;
    additionalDescription: string;
    totalProductPrice: string;
    setPrice: string;
    articelSetConsistsOf: string;
    gratis: string;
    details: string;
    toTheDetailsPage: string;
    viewAllSets: string;
    flexibleSetAddedToBasket: string;
    currentlyNotAvailable: string;
    selectYourArticle: string;
    changeSetComponents: string;
    setParts: string;
    selectFlexibleSet: string;
    setView: string;
    productsAvailable: string;
    chooseProductsAndVariant: string;
    chooseProducts: string;
    chooseVariant: string;
    showDetails: string;
    sets: string;
    set: string;
    containsFreeArticle: string;
    setArticleCountSingle: string;
    setArticleCountMany: string;
    variants: string;
    variant: string;
    select: string;
    seasonalNote: string;
}

export interface IRedOnlyL10n {
    trouserFinderLogo: string;
    trouserFinderTitle: string;
    trouserFinderSubTitle: string;
    jacketFinderLogo: string;
    jacketFinderTitle: string;
    jacketFinderSubTitle: string;
    shoeFinderLogo: string;
    shoeFinderTitle: string;
    shoeFinderSubTitle: string;
    findYourPerfectTrousersIn3SimpleSteps: string;
    areYouLookingForThePerfectWorkTrousers: string;
    findYourPerfectJacketIn3SimpleSteps;
    areYouLookingForThePerfectJacket;
    justaFewStepsToThePerfectFootwear: string;
    areYouLookingForThePerfectShoe: string;
    goToTrouserFinder: string;
    goToJacketFinder: string;
    goToShoeFinder
    aasTitle: string;
    aasSubTitle: string;
    aasBackToProduct: string;
    purchaseAdvice: string;
    productFeature: string;
    disclaimerGLB: string;
}

// export interface IWWSOnlyL10n {
//     workWearStoresLink: string;
//     workwearStoreAvailabilityCheck: string;
//     workwearStoreAvailabilityFallback: string;
//     checkWorkwearstoreAvailability: string;
//     checkAllVariants: string;
//     currentlyAvailable: string;
//     notAvailable: string;
//     currentlyNotAvailable: string;
//     infoSoldOut: string;
//     openingHoursAndAdditionalInfo: string;
//     storeAvailabilityLocale: string;
//     notAvailableInWorkwearStore: string;
//     wwsLocallyAvailable: string;
//     wwsLocallyNotAvailable: string;
// }

export interface IGLBOnlyL10n {
    deliveryDateShortGLBLocale: string;
    deliveryDateLongGLBLocale: string;
}

export interface IColor {
    code: number;
    name: string;
}

export interface IAvailableColor extends IColor {
    iconPath: string;
    defaultArticleImagePath: string;
    salesArticleVariantKey: string;
}

export interface IModel {
    code: number;
    label: string;
}

export interface IAvailableModel extends IModel {
    salesArticleVariantKey: string;
    defaultArticleImagePath: string;
}

export interface ISize {
    code: number;
    fittingAccuracy?: number;
    label: string;
    name: string;
}

export interface ISalesArticleVariantSize {
    salesArticleVariantKey: string;
    size: ISize;
}

export interface ISizeType {
    sizeTypeCode: number;
    sizeTypeName: string;
    sizes: ISalesArticleVariantSize[];
}

export interface ITranslationUrls {
    culture: string;
    url: string;
}

export enum VariantType {
    Color,
    Size,
    Special,
    Model,
    None,
    Kiosk, // special type for kiosk only. If we have color, show color panel. Otherwise, show size panel
}

export class ArticleState {
    public static Actual = 'Actual';
    public static Obsoleted = 'Obsoleted';
}
